import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43ab2af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import kardiasschema from "@/../../EshJSLib/models/form/kardias.json";
import fileschema from "@/../../EshJSLib/models/form/files.json";
import checkMeProView from "../ble/view/CheckMeProView.vue"
import dHeart from "../ble/view/DHeart.vue"
import { saveFile, deleteFile, updateFile } from "@/../../EshJSLib/services/fileServices";

import { Kardias, File } from "@/../../EshJSLib/models/patient";
import { ref, onMounted, reactive } from "vue";
import { Modal, Input } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import ModalNewFile from "./modal_addnewfile.vue"
import ModalEditFile from "./modal_editfile.vue"
import ModalKardiaPreview from "./modal_anteprima.vue"
import ModalDeleteFile from "./modal_delete.vue"
import ModalConfidenzialita from "./modal_confidenzialita.vue"
import { previewKardia } from "@/../../EshJSLib/services/kardiaServices";
import { useRouter } from "vue-router";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";


interface modalForms {
  kardia_delete: boolean
  file_delete: boolean,
  kardia_upload: boolean
  file_upload: boolean
  confidentiality: boolean
  kardia_preview: boolean
  file_preview: boolean
  alert: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'fileDispositiviPage',
  setup(__props) {

const router = useRouter();
const isShownModalSub = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: 'Paypal' })
}

//Ref Element with HTML
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const modalEditFile = ref<InstanceType<typeof ModalEditFile> | null>(null);
const modalKardiaPreview = ref<InstanceType<typeof ModalKardiaPreview> | null>(null);
const modalDeleteFile = ref<InstanceType<typeof ModalDeleteFile> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof ModalConfidenzialita> | null>(null);
const modalAddFile = ref<InstanceType<typeof ModalNewFile> | null>(null);
const data = ref({} as CollapsableModel);

const store = patientStore();
const { patient } = storeToRefs(store);
const modal_status = reactive({} as modalForms);
const showLoading = ref(false);
const imageDataUrl = ref("");

let filenew = reactive({
  id_paziente: patient.value.id_paziente,
  id_autore: patient.value.id_paziente,
  id_audit_log: 1,
  id_file: null,
  file_commento: '',
  file_nome: '',
  file_type: '',
  file: null,
  type: '',
  tags: '',
  file_size: 0,
  data_rilievo: null,
  id_livello_confidenzialita: 1,
});

// const props = defineProps({
//     data: CollapsableModel,
// });

let schema = ref('');
async function action(type: string, row: File) {
  let userInput;

  switch (type) {
    case "eye":
      // userInput = await modalKardiaPreview.value?.openModal("Kardia", true, row);
      // if (userInput) {
        previewKardia(row.id_file);
      // }
      break;

    case "download": {
      userInput = await alertModal.value?.openModal("Scaricare il File?", true);
      if (userInput) {
        showLoading.value = true;
        const downloadData = await store.fetchDownloadUrl(row.id_file);
        window.open(downloadData.data as unknown as URL, "_blank");
        showLoading.value = false;
        alertModal.value?.openModal("File scaricato con successo! ", false);
      }
      break;
    }

    case "trash":
      alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((userInput) => {
        if (userInput) {
          row.status = 'delete';
          showLoading.value = true;
          deleteFile(row.id_file)
            .then((response) => {
              showLoading.value = false;
              if (response.status === 200) {
                alertModal.value?.openModal("File eliminato con successo!", false);
              }
              store.fetchFiles();
              store.fetchKardias();
            })
            .catch((error) => {
              showLoading.value = false;
              alertModal.value?.openModal("Non puoi eliminare questo file", false);
              store.fetchFiles();
              store.fetchKardias();
            });
        }
      });
      break;


    case "pen":
      if (await hasPermission('modificafile')) {
        userInput = await modalEditFile.value?.openModal("Modifica file", true, row);
        if (userInput) {
          showLoading.value = true;
          updateFile(row).then(() => {
            showLoading.value = false;
            alertModal.value?.openModal("File cambiato con successo!", false);
            store.fetchFiles();
            store.fetchKardias();
          });
        }
      } else {
        isShownModalSub.alert = true;
      }
      break;

    case "lock":
      userInput = await modalConfidenzialita.value?.openModal("Seleziona il livello di confidenzialità ", true, row);
      if (userInput) {
        showLoading.value = true;
        updateFile(row).then(() => {
          showLoading.value = false;
          alertModal.value?.openModal("Confidenzialità modificata con successo!", false);
        });
      }
      break;

    case "newRecord":
      var id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza
      if (await hasPermission('aggiungifile')) {
        filenew = {
          id_paziente: patient.value.id_paziente,
          id_autore: patient.value.id_paziente,
          id_audit_log: 132,
          id_file: null,
          file_commento: '',
          file_nome: '',
          file_type: '',
          file: null,
          type: '',
          tags: '',
          file_size: 0,
          data_rilievo: null,
          id_livello_confidenzialita: 1,
        };
        userInput = await modalAddFile.value?.openModal("Aggiungi file: ", filenew, true);
        if (userInput) {
          showLoading.value = true;
          try {
            await saveFileFE(filenew).then(() => {
              showLoading.value = false;
              alertModal.value?.openModal("File salvato con successo!", false);
            });
          } catch (e) {
            showLoading.value = false;
            console.log(e);
            alertModal.value?.openModal("Si è verificato un problema nel caricamento del file. Prova a riprovare più tardi. Se il problema persiste segnalalo scrivendo ad info\u0040micurobene.it", false);
          }
        }
      } else {
        isShownModalSub.alert = true;
      }
      break;

    default:
      break;
  }
}

async function saveFileFE(filenew: any) {
  // if (!filenew.type || !filenew.id_livello_confidenzialita) {
  //   return;
  // }
  try {
    const payload = filenew;
    const data = await saveFile(payload);
    store.fetchFiles();
    store.fetchKardias();
  } catch (e) {
    store.fetchFiles();
    store.fetchKardias();
  }
}

onMounted(async () => {
  store.fetchFiles();
  store.fetchKardias();
});

const dataModelCompletati = new CollapsableModel();

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ModalEditFile, {
          ref_key: "modalEditFile",
          ref: modalEditFile
        }, null, 512),
        _createVNode(ModalKardiaPreview, {
          ref_key: "modalKardiaPreview",
          ref: modalKardiaPreview
        }, null, 512),
        _createVNode(ModalDeleteFile, {
          ref_key: "modalDeleteFile",
          ref: modalDeleteFile
        }, null, 512),
        _createVNode(ModalConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(ModalNewFile, {
          ref_key: "modalAddFile",
          ref: modalAddFile,
          schema: _unref(schema)
        }, null, 8, ["schema"]),
        (modal_status.file_upload)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 0,
              size: "2xl",
              onClose: _cache[0] || (_cache[0] = ($event: any) => (modal_status.file_upload = false))
            }))
          : _createCommentVNode("", true),
        (modal_status.file_preview)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 1,
              size: "2xl",
              onClose: _cache[1] || (_cache[1] = ($event: any) => (modal_status.file_preview = false))
            }))
          : _createCommentVNode("", true),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 2 }))
          : _createCommentVNode("", true),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        _createVNode(CollapsibleItem, {
          data: _unref(kardiasschema),
          onRowActions: action,
          onCreateForm: _cache[2] || (_cache[2] = ($event: any) => (action('newRecord', null))),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(schema) //@ts-ignore
 ? schema.value = 'kardiasschema' : schema = 'kardiasschema'))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(fileschema),
          onRowActions: action,
          onCreateForm: _cache[4] || (_cache[4] = ($event: any) => (action('newRecord', null))),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(schema) //@ts-ignore
 ? schema.value = 'fileschema' : schema = 'fileschema'))
        }, null, 8, ["data"]),
        _createVNode(checkMeProView),
        _createVNode(dHeart),
        (isShownModalSub.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 3,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (isShownModalSub.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isShownModalSub.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})